// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LinkRemove: React.FC<{ size?: number; color1?: string; className?: string }> = ({
    size = 9,
    color1 = "#e00b5a",
    className,
}) => (
    <svg className={className} focusable="false" viewBox="0 0 9 9" width={size} height={size}>
        <path
            fill="currentColor"
            d="M8.074 8.64c.155.155.41.155.566 0a.4.4 0 0 0 0-.566L5.322 4.756 8.64 1.438a.4.4 0 0 0 0-.566.4.4 0 0 0-.566 0L4.756 4.19 1.438.872a.4.4 0 0 0-.566 0 .4.4 0 0 0 0 .566L4.19 4.756.872 8.074a.4.4 0 0 0 0 .566.403.403 0 0 0 .566 0l3.318-3.318z"
        />
    </svg>
);

export default React.memo(LinkRemove);
